
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { StatValue } from '@/generated-clients/bff';
import ChevronRight from '@components/icons/icon-chevron-right.svg';
import { durationTime } from '@util/dates-and-times/duration';

@Component({
  name: 'StatValueDisplay',
  components: {
    ChevronRight
  }
})
export default class StatValueDisplay extends Vue {
  @Prop({ required: true })
  private statValue: StatValue;

  get isDuration() {
    return this.statValue.unit === 'min';
  }

  get intValue() {
    return parseInt(this.statValue.value);
  }

  get days() {
    return this.time.days;
  }

  get hours() {
    return this.time.hours;
  }

  get minutes() {
    return this.time.minutes;
  }

  get time() {
    return durationTime(parseInt(this.statValue.value));
  }
}
